import { useLocation } from 'react-router-dom';
export const REGISTER_PATH = '/register';

export const useIsRegisterPath = () => {
  const activeLink = useLocation().pathname;
  return activeLink.includes(REGISTER_PATH);
};
